import { render } from "./sjksh.vue?vue&type=template&id=295ec476&scoped=true"
import script from "./sjksh.vue?vue&type=script&lang=js"
export * from "./sjksh.vue?vue&type=script&lang=js"

import "./sjksh.vue?vue&type=style&index=0&id=295ec476&scoped=true&lang=css"

import exportComponent from "D:\\智诚大数据\\禁种铲毒\\禁种铲毒平台\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-295ec476"]])

export default __exports__